module.exports = __webpack_public_path__ + "static/media/header.50ce2657.png";